import { apiClient } from '@/lib/api/client'

const EASEL_BASE = '/api/v1/easel'

export interface BioSection {
  id: number
  position: number
  title: string
  description: string | null
  contentHtml: string
  artworkIds?: number[]
  status: 'draft' | 'published'
}

export interface BioState {
  published: BioSection[]
  draft: BioSection[]
  hasDraft: boolean
}

/** Where a publish sent the words, reported per destination so a partial fan-out is visible. */
export interface BioDistribution {
  sections: number
  shopify: { attempted: boolean; ok?: boolean; error?: string; chars?: number; collectionId?: string | null }
  storefront: { attempted: boolean; ok?: boolean; error?: string; paragraphs?: number; reason?: string }
}

export interface BioPublishResult {
  published: boolean
  sections: number
  distribution: BioDistribution
}

export const bioApi = {
  get: async (): Promise<BioState> => {
    const res = await apiClient.get<{ data: BioState }>(`${EASEL_BASE}/editorial/bio`)
    return res.data.data
  },

  /** Drafts a fresh biography. Persists as drafts — nothing becomes public. */
  regenerate: async (): Promise<unknown> => {
    const res = await apiClient.post(`${EASEL_BASE}/editorial/bio/regenerate`)
    return res.data
  },

  publish: async (
    sections: Pick<BioSection, 'title' | 'description' | 'contentHtml'>[],
    targets: { publishToMarketplace?: boolean; publishToStorefront?: boolean } = {}
  ): Promise<BioPublishResult> => {
    const res = await apiClient.post<{ data: BioPublishResult }>(`${EASEL_BASE}/editorial/bio/publish`, {
      sections: sections.map((s) => ({
        title: s.title,
        description: s.description,
        content_html: s.contentHtml,
      })),
      ...targets,
    })
    return res.data.data
  },
}
